import React from "react";
import FavoriteIcon from "@mui/icons-material/Favorite";

const Footer = () => {
  return (
    <footer className="relative w-full bottom-0">
      <div className=" h-12 w-full flex justify-center items-center bg-yellow-300 text-gray1">
        <span className="flex items-center mr-3">Made with</span>
        <span className="flex items-center mr-3">
          <FavoriteIcon className="text-red-600" />
        </span>
        <span className="flex items-center mr-3">by</span>
        <span className="flex items-center mr-3">
          <a
            href="https://www.linkedin.com/in/aniketnegi/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Aniket
          </a>
        </span>
        <span className="flex items-center mr-3">on</span>
        <a
          href="https://reactjs.org/"
          target="_blank"
          rel="noopener noreferrer"
        >
          ReactJS
        </a>
      </div>
    </footer>
  );
};

export default Footer;
